export const navigationMenu = {
  NEW: "new",
  PENDING: "pending",
  FINISHED: "finished"
};

export const permissionRole = {
  RJPADMIN: 20,
}